import { useState, useRef } from "react";
import { Space, Table } from "antd";
import SearchInput from "../../../components/utils/SearchInput";
import { replaceString } from "../../../utils/helpers/dataHelper";
import CategoryDropDown from "./CategoryDropDown";
import AssignRoleModal from "../../../components/modals/admin/member/AssignRoleModal";
import AssignDropDown from "./AssignDropDown";
import { stringSorter } from "../../../utils/helpers/dataHelper";
import { Loading } from "../../../utils/helpers/constants";
import RoundLoader from "../../../components/loader/RoundLoader";

const AntTable = ({
  statusState,
  studentList,
  handleView,
  handleSearch,
  handleDelete,
  handleCreate,
  handleFilter,
  retractOffice,
}) => {
  const [openRole, setRoleOpen] = useState(false);
  const [openOffice, setOfficeOpen] = useState(false);
  const [userWithRole, setUserWithRole] = useState("");
  const cancelButtonRef = useRef(null);

  const handleUserRole = (record) => {
    setUserWithRole(record);
    setRoleOpen(true);
  };

  const handleOffice = (record) => {
    setUserWithRole(record);
    setOfficeOpen(true);
  };

  const handleSuspend = (record) => {
    setUserWithRole(record);
    setOfficeOpen(true);
  };

  const roleList = [
    { name: "User Role", value: "ROLE_USER", desc: "has basic role" },
    {
      name: "Super Admin Role",
      value: "ROLE_SUPER_ADMIN",
      desc: "has permission to perform admin functions",
    },
  ];

  const officeList = [
    { name: "BOT", value: "BOARD_OF_TRUSTEE", desc: "has basic role" },
    {
      name: "Executive",
      value: "EXECUTIVE",
      desc: "has permission to perform admin functions",
    },
    { name: "Chapter Lead", value: "CHAPTER_LEAD", desc: "has basic role" },
  ];

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      render: (firstName) => <span className="">{firstName}</span>,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      render: (lastName) => <span className="">{lastName}</span>,
    },
    {
      title: "Middle Name",
      dataIndex: "middleName",
      key: "middleName",
      render: (middleName) => <span className="">{middleName}</span>,
    },
    {
      title: "Matric Number",
      dataIndex: "matricNumber",
      key: "matricNumber",
      render: (matricNumber) => <span className="">{matricNumber}</span>,
      sorter: (a, b) => stringSorter(a.matricNumber, b.matricNumber),
    },
    {
      title: "Graduation Year",
      dataIndex: "graduationYear",
      key: "graduationYear",
      render: (graduationYear) => <span className="">{graduationYear}</span>,
      sorter: (a, b) => stringSorter(a.graduationYear, b.graduationYear),
    },
    {
      title: "Set Name",
      dataIndex: "setName",
      key: "setName",
      render: (setName) => <span className="">{setName}</span>,
    },
    {
      title: "Phone Name",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      render: (phoneNumber) => <span className="">0{phoneNumber}</span>,
    },
    {
      title: "Program",
      dataIndex: "program",
      key: "program",
      render: (program) => <span className="">{program}</span>,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (gender) => <span className="">{gender}</span>,
    },
    {
      title: "Status",
      dataIndex: "accountStatus",
      key: "accountStatus",
      render: (accountStatus) => <span className="">{accountStatus}</span>,
    },
    {
      title: "Office",
      key: "officeType",
      render: (record) => (
        <>
          {record?.officeType === null ? (
            "None"
          ) : (
            <>{replaceString(record?.officeType)}</>
          )}
        </>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <AssignDropDown
            record={record}
            handleAppRole={() => handleUserRole(record)}
            handleOffice={() => handleOffice(record)}
            handleView={() => handleView(record)}
            handleSuspend={() => handleSuspend(record)}
            handleDelete={() => handleDelete(record)}
            handleRetractOffice={() => retractOffice(record)}
          />
        </Space>
      ),
    },
  ];

  const loadState = statusState === Loading.FETCHING;

  return (
    <div>
      <div>
        <button
          className="bg-green-800 text-white rounded-md p-2 px-4"
          onClick={() => handleCreate()}
        >
          Add Member
        </button>
      </div>
      <div className="flex justify-between items-center py-4 bg-white dark:bg-gray-800">
        <div>
          <CategoryDropDown handleFilter={(payload) => handleFilter(payload)} />
        </div>
        <SearchInput handleSearch={(value) => handleSearch(value)} />
      </div>
      {loadState ? (
        <RoundLoader />
      ) : (
        <Table
          columns={columns}
          pagination={{}}
          dataSource={studentList}
          scroll={{
            x: 1500,
          }}
          sticky
        />
      )}
      <AssignRoleModal
        dropDown={roleList}
        header={"ROLE"}
        open={openRole}
        user={userWithRole}
        setOpen={setRoleOpen}
        cancelButtonRef={cancelButtonRef}
      />
      <AssignRoleModal
        dropDown={officeList}
        header={"OFFICE"}
        description={""}
        open={openOffice}
        user={userWithRole}
        setOpen={setOfficeOpen}
        cancelButtonRef={cancelButtonRef}
      />
    </div>
  );
};

export default AntTable;
